var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolicies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.048,
    height: 26.109,
    viewBox: "0 0 23.048 26.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19045",
    "data-name": "Group 19045",
    transform: "translate(12402.177 20260)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20462",
    "data-name": "Path 20462",
    d: "M39.411,13.242h4.2L39.14,8.757V12.97A.272.272,0,0,0,39.411,13.242Z",
    transform: "translate(-12425.908 -20268.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19041",
    "data-name": "Group 19041",
    transform: "translate(-12402.177 -20244.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20463",
    "data-name": "Path 20463",
    d: "M10.823,44.811V37.335a.544.544,0,0,1,.544-.544h2.726a.544.544,0,0,1,.544.544v7.476a.544.544,0,0,1-.544.544H11.367A.544.544,0,0,1,10.823,44.811Z",
    transform: "translate(-10.823 -36.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20464",
    "data-name": "Path 20464",
    d: "M29.29,47.764l7.5-2.971a1.783,1.783,0,0,0,1.1-2.206A1.98,1.98,0,0,0,35.61,41.34l-3.514.716a2.181,2.181,0,0,1-.307,1.142,2.635,2.635,0,0,1-3.381.926l-5.691-2.805a.544.544,0,0,1,.482-.976l5.691,2.805a1.528,1.528,0,0,0,1.966-.509,1.1,1.1,0,0,0,.117-.882,1.274,1.274,0,0,0-.682-.775l-5.077-2.5a2.729,2.729,0,0,0-.9-.134h-3.94a.544.544,0,0,0-.544.544v5.778a.544.544,0,0,0,.544.544h1.778l5.106,2.473a2.507,2.507,0,0,0,2.029.079Z",
    transform: "translate(-14.931 -37.499)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20465",
    "data-name": "Path 20465",
    d: "M28.732,13.986a1.359,1.359,0,0,1-1.355-1.36V8H18.092a2.386,2.386,0,0,0-2.379,2.389v12.19h.592a1.628,1.628,0,0,1,1.5,1,1.6,1.6,0,0,1,.671-.15H22.4a3.774,3.774,0,0,1,1.256.2,1.128,1.128,0,0,1,.115.049l5.057,2.5a2.4,2.4,0,0,1,1.054.995l3.458-.708V13.986H28.733Zm.919,8.47H19.5a.544.544,0,0,1,0-1.088H29.65a.544.544,0,0,1,0,1.088Zm0-3.076H19.5a.544.544,0,0,1,0-1.088H29.65a.544.544,0,0,1,0,1.088Zm0-3.076H19.5a.544.544,0,0,1,0-1.088H29.65a.544.544,0,0,1,0,1.088Z",
    transform: "translate(-12415.229 -20268)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicies);
export default __webpack_public_path__ + "static/media/policies.da70c6c01aca5893fc7bbdb8e07553d3.svg";
export { ForwardRef as ReactComponent };